import PropTypes from 'prop-types'
import { styled } from 'styled-components'

import { useRect } from 'core/hooks'
import { useBootstrapStore } from 'core/stores'
import variables from 'core/styles/variables'

import TermsAndConditions from './TermsAndConditions'

const Card = styled.div`
  margin: auto;
  border-radius: 6px;
  box-shadow: ${variables.peachyShadow};
  background: ${variables.colorWhite};
  padding: ${(p) => (p.isCompact ? '16px' : '28px 40px')};
  max-width: 480px;
`

const TitleArea = styled.div`
  padding-bottom: 32px;
`

const Title = styled.div`
  color: ${variables.colorBlack90};
  font-size: 28px;
  font-weight: 500;
`

const Contents = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-top: 32px;

    &:first-child {
      margin-top: 0;
    }
  }
`

const TITLES = {
  agent: 'Agent Login',
  borrower: 'Account Login',
  admin: 'Admin Login',
}

const LoginFormCard = ({ children }) => {
  const { appDomainType, userType, consent } = useBootstrapStore((data) => ({
    appDomainType: data?.appDomainType,
    userType: data?.userType,
    consent: data?.company?.brandAssets?.copies?.consent,
  }))

  const [{ width }, ref] = useRect()

  const isCompact = width < 420

  const title = TITLES[appDomainType] || 'Login'

  // Show terms and conditions for borrowers if consent is configured (truthy; excludes '', null, undefined)
  const showTermsAndConditions = userType === 'borrower' && consent

  return (
    <Card isCompact={isCompact} ref={ref}>
      {title && (
        <TitleArea>
          <Title>{title}</Title>
        </TitleArea>
      )}

      <Contents>
        {children}
        {showTermsAndConditions && <TermsAndConditions consent={consent} />}
      </Contents>
    </Card>
  )
}

LoginFormCard.propTypes = {
  children: PropTypes.node,
}

export default LoginFormCard
